(function () {
    'use strict';
    $(document).ready(function () {

        $(".play-video").modalVideo({
            channel: 'vimeo'
        });

        var swiperTeams = new Swiper('.homepage .swiper-teams', {
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: {
                delay: 3000
            }
        });

        var swiperBanners = new Swiper('.homepage .swiper-banners', {
            loop: true,
            effect: 'fade',
            speed: 600,
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                delay: 5000
            },
            navigation: {
                nextEl: '.swiper-go-right',
            }
        });

        if ($('.homepage').length) {
            $("#calendar").MEC({
                from_monday: true,
                events: db_events
            });

            getEvents();
        }

        $('#js-calendar-toggle').on('click', function (e) {
            e.preventDefault();
            $('#calendar').fadeToggle();
        });

        $('body').on('click touchend', '#calendar #calTbody button.a-date.event', function (e) {
            e.preventDefault();
            $('#calendar').fadeOut();
            var dataDate = $(this).data('event');
            var date = dataDate.date.split('T')[0];
            var year = date.split('-')[0];
            var month = date.split('-')[1];
            var day = date.split('-')[2];

            var dayDisplay = $(this).find('span').text();

            getEvents(year, month, day);
        });

        function getEvents(year, month, day) {
            $.ajax({
                url: "/wp-admin/admin-ajax.php",
                method: "post",
                timeout: 10000,
                data: {
                    action: "get_events",
                    year: year,
                    month: month,
                    day: day
                },
                success: function (data) {
                    $('#events-from-ajax').html(data).slideDown();
                    $('.day-number').html($("#cal-day").val());
                    $('.day-name').html($("#cal-month").val());
                    var swiperEvents = new Swiper('.homepage .swiper-events', {
                        spaceBetween: 30,
                        pagination: {
                            el: '.swiper-pagination',
                        },
                    });
                },
                error: function (error) {
                    console.log(error);
                    $('.ajax-info-events .loading-error').slideDown();
                },
                beforeSend: function () {
                    $('#events-from-ajax').slideUp();
                    $('.ajax-info-events .loading-error').slideUp();
                    $('.ajax-info-events .loader').slideDown();
                },
                complete: function () {
                    $('.ajax-info-events .loader').slideUp();
                }
            });
        }

    });
}(jQuery));
